import { m } from '@aimfora/i18n'
import {
  Button,
  cn,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@aimfora/ui'

/** [task, max points, AI points, needs a check] */
const ROWS: ReadonlyArray<readonly [string, number, number, boolean]> = [
  ['1.1', 2, 2, false],
  ['1.2', 2, 2, false],
  ['2.2', 3, 1, true],
  ['2.3', 2, 2, false],
  ['3.3', 3, 2, false],
]

/** A static example of the review screen. It shows the idea without loading any data. */
export function GradingPreview() {
  return (
    <div
      className="overflow-hidden rounded-md border border-line bg-surface shadow-[0_12px_40px_rgba(30,43,58,0.10)]"
      aria-hidden="true"
    >
      <div className="flex items-center justify-between border-line border-b px-4 py-3">
        <span className="font-semibold text-sm">{m.forside_preview_student()}</span>
        <span className="text-[12px] text-ink-soft">{m.forside_preview_status()}</span>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{m.forside_preview_col_task()}</TableHead>
            <TableHead className="text-right">{m.forside_preview_col_max()}</TableHead>
            <TableHead className="text-right">{m.forside_preview_col_ai()}</TableHead>
            <TableHead className="text-right">{m.forside_preview_col_yours()}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {ROWS.map(([task, max, ai, check]) => (
            <TableRow key={task}>
              <TableCell>
                <span className="font-medium">{m.forside_preview_task({ number: task })}</span>
                {check && (
                  <span className="ml-2 inline-flex h-5 items-center rounded-full bg-pen-soft px-1.5 font-semibold text-[11.5px] text-pen">
                    {m.forside_preview_check()}
                  </span>
                )}
              </TableCell>
              <TableCell className="num text-right text-ink-soft">{max}</TableCell>
              <TableCell className="num text-right">{ai}</TableCell>
              <TableCell className="text-right">
                <span
                  className={cn(
                    'num inline-flex h-7 w-14 items-center justify-end rounded-md border px-2',
                    check ? 'border-saffron bg-saffron-soft' : 'border-line',
                  )}
                >
                  {ai}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className="flex items-center justify-between border-line border-t bg-paper/60 px-4 py-3">
        <span className="text-sm">
          <span className="num font-semibold">17</span>{' '}
          <span className="text-ink-soft">{m.forside_preview_total()}</span>
        </span>
        <span className="inline-flex items-center gap-3">
          <span className="num inline-flex h-9 w-12 items-center justify-center rounded-md border-2 border-ink-soft border-dashed font-semibold">
            7
          </span>
          <Button size="sm" className="pointer-events-none" tabIndex={-1}>
            {m.forside_preview_approve()}
          </Button>
        </span>
      </div>
    </div>
  )
}
